import { Divider, MUITypography } from "@cobee/cobee-ui";
import { useTranslation } from "react-i18next";
import Request, {
  RequestStates,
} from "v2/domain/benefitRequest/entities/Request";
import DetailRow from "../DetailRow";
import styles from "./styles";

export default function FinishedRequestInfo({
  data,
}: {
  data: Request;
}): JSX.Element {
  const { t } = useTranslation();
  const { emailMessageText } = styles;

  const shouldShowEmailMessage =
    data?.state === RequestStates.APPROVED ||
    data?.state === RequestStates.DENIED;

  const emailMessage = {
    [RequestStates.APPROVED]: t(
      "v2.benefit-requests.this-employee-will-be-notified-approved-request-via-email"
    ),
    [RequestStates.DENIED]: t(
      "v2.benefit-requests.this-employee-will-be-notified-rejected-request-via-email"
    ),
  };

  const processigDateType = {
    [RequestStates.APPROVED]: data.approvedDate,
    [RequestStates.DENIED]: data.deniedDate,
    [RequestStates.CANCELLED]: data.cancelledDate,
  };

  const colorConfig = {
    [RequestStates.APPROVED]: "primary.dark",
    [RequestStates.DENIED]: "error.dark",
    [RequestStates.CANCELLED]: "grey.700",
  };

  return (
    <>
      <DetailRow
        label={t("v2.common.processing-date")}
        value={processigDateType[data.state].toLocaleDateString() || ""}
      />
      <DetailRow
        label={t("v2.common.state")}
        value={t(`v2.benefit-requests.statuses.${data?.state}`)}
        color={colorConfig[data.state] || "primary.dark"}
      />
      <Divider margin={12} />
      {shouldShowEmailMessage && (
        <MUITypography variant="body2" sx={emailMessageText}>
          {emailMessage[data?.state as string]}
        </MUITypography>
      )}
    </>
  );
}
